// Główny plik JS
// Główny plik JS - Obsługa menu mobilnego
document.addEventListener('DOMContentLoaded', () => {
    const mobileBtn = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');

    if (mobileBtn && mobileMenu) {
        mobileBtn.addEventListener('click', () => {
            // Przełączanie klasy 'hidden' z Tailwind CSS
            mobileMenu.classList.toggle('hidden');
            
            // Opcjonalnie: logowanie w konsoli dla testu
            console.log('Menu mobilne przełączone');
        });
    }
});

// Zamknij menu mobilne po kliknięciu w dowolny link z klasą .mobile-link
const mobileLinks = document.querySelectorAll('.mobile-link');
const mobileMenu = document.getElementById('mobile-menu');

mobileLinks.forEach(link => {
    link.addEventListener('click', () => {
        mobileMenu.classList.add('hidden');
    });
});



// Obsługa filtrowania portfolio
const filterButtons = document.querySelectorAll('.filter-btn');
const portfolioItems = document.querySelectorAll('.portfolio-item');

filterButtons.forEach(btn => {
    btn.addEventListener('click', () => {
        // Usuń klasę active ze wszystkich przycisków
        filterButtons.forEach(b => b.classList.remove('active', 'bg-fuchsia-600', 'text-white'));
        filterButtons.forEach(b => b.classList.add('border-gray-200','hover:border-fuchsia-600','hover:text-fuchsia-600'));

        // Dodaj klasę active do klikniętego
        btn.classList.add('active', 'bg-fuchsia-600', 'text-white');
        btn.classList.remove('border-gray-200','hover:border-fuchsia-600','hover:text-fuchsia-600');

        const filterValue = btn.getAttribute('data-filter');

        portfolioItems.forEach(item => {
            if (filterValue === 'all' || item.getAttribute('data-category') === filterValue) {
                item.style.display = 'block';
                // Dodaj lekką animację wejścia
                item.classList.add('animate-in', 'fade-in', 'zoom-in-95', 'duration-300');
            } else {
                item.style.display = 'none';
            }
        });
    });
});